import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40edd9d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = ["onDragstart", "onDragenter"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]

import {onUnmounted, reactive} from "vue";
import {message, UploadFile} from "ant-design-vue";
import {
  DragOutlined,
  CloseOutlined,
  CloudUploadOutlined,
  CloudOutlined,
  CheckOutlined,
} from "@ant-design/icons-vue";
import {account} from "@/app/login";
import {fileResize, IconFont, Json, req} from "@/lib/util";
import {editor} from "@/app/editor";
import {LazyImg, Waterfall} from 'vue-waterfall-plugin-next'
import 'vue-waterfall-plugin-next/dist/style.css'
import BlockView from "@/components/block/BlockView.vue";
import BlockTitleView from "@/components/block/BlockTitleView.vue";
import {IntroductionSectionV1} from "@/app/editor/modules/introduction/v1/index";
import BlockContentItemKey from "@/components/block/BlockContentItemKey.vue";
import BlockContentBox from "@/components/block/BlockContentBox.vue";
import BlockContentItemValue from "@/components/block/BlockContentItemValue.vue";
import {ViewCard} from "vue-waterfall-plugin-next/dist/types/types/waterfall";
import {toTopic, unSub} from "@/lib/session";
import emit from "@/lib/emit";
import WxUploaderButton from "@/components/WxUploaderButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IntroductionSetup',
  props: {
    index: {}
  },
  setup(__props: any) {

const props = __props
const introduction = editor.activity?.modules[props.index] as IntroductionSectionV1
const info = reactive({
  uploader: {files: {} as { [key: string]: any }},
  pictures: {open: false, urls: introduction.config.content_images}
})

onUnmounted(() => {
  unSub(editor.activity?.id ?? '')
  emit.off(toTopic(editor.activity?.id ?? ''))
})

let dragPosition = 0
const onDragStart = (ev: DragEvent, i: number) => {
  // console.log('onDragStart', ev, i)
  ev.stopPropagation()
  dragPosition = i
  setTimeout(() => (ev.target as HTMLImageElement).classList.add('moveing'), 0)
}
const onDragEnter = (ev: DragEvent, i: number) => {
  // console.log('onDragEnter', ev, i)
  ev.preventDefault()
  if (!introduction) return
  if (dragPosition != i) {
    const s = introduction.config.content_images[dragPosition]
    introduction.config.content_images.splice(dragPosition, 1)
    introduction.config.content_images.splice(i, 0, s)
    dragPosition = i
  }
}
const onDragEnd = (ev: DragEvent) => {
  (ev.target as HTMLImageElement).classList.remove('moveing')
  // console.log('onDragEnd', ev)
}
const onDragOver = (ev: DragEvent) => {
  // console.log('onDragOver', ev)
  ev.preventDefault()
  if (ev.dataTransfer) ev.dataTransfer.dropEffect = 'move'
}

const uploadData = (f: UploadFile): object => {
  console.log('upload data:', f, info.uploader.files[f.uid])
  return info.uploader.files[f.uid]
}

const beforeUpload = (f: UploadFile): Promise<UploadFile> | boolean => {
  if (!account.shop?.sid) {
    message.warn({content: '账号异常，请重新登录'})
    return false
  }
  info.uploader.files[f.uid] = {key: `media/temp/${Math.random().toString(36).slice(2)}.${f.name.split('.').pop()}`}
  return new Promise((resolve, reject) => {
    req({
      url: 'fs/token', method: 'POST', data: {key: info.uploader.files[f.uid].key}, success: rs => {
        Object.keys(rs).forEach(k => info.uploader.files[f.uid][k] = rs[k])
        fileResize(f).then(tf => resolve(tf)).catch(reject)
      }, fail: reject
    })
  })
}

const onUploadChange = (j: Json) => {
  const f = j.file as UploadFile
  if (f.status == 'done') {
    f.url = 'https://activity.djhdb.cn/' + info.uploader.files[f.uid].key
    if (f.url.endsWith('mp4')) f.thumbUrl = require('@/assets/image/mp4.png')
    else f.thumbUrl = f.url + '-sq.200'
    introduction?.config.content_images.push(f.url)
  } else if (f.status == 'error') {
    const doc = new DOMParser().parseFromString(f.response, 'application/xml')
    message.error(doc.getElementsByTagName('Message')[0].childNodes[0].nodeValue)
  }
}


const onPictureClick = (imageUrl: string) => {
  if (introduction.config.content_images.find(i => i == imageUrl)) introduction.config.content_images.splice(introduction.config.content_images.indexOf(imageUrl), 1)
  else introduction.config.content_images.push(imageUrl)
}


return (_ctx: any,_cache: any) => {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_typography_link = _resolveComponent("a-typography-link")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_unref(introduction))
    ? (_openBlock(), _createBlock(BlockView, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(BlockTitleView, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IconFont), {
                type: `icon-${_unref(introduction).icon}`,
                style: {"padding-right":"8px"}
              }, null, 8, ["type"]),
              _createTextVNode(" " + _toDisplayString(_unref(introduction).title), 1)
            ]),
            _: 1
          }),
          _createVNode(BlockContentBox, null, {
            default: _withCtx(() => [
              _createVNode(BlockContentItemKey, null, {
                default: _withCtx(() => [
                  _createTextVNode("标题样式")
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemValue, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    value: _unref(introduction).config.shop_style,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(introduction).config.shop_style) = $event)),
                    "button-style": "solid"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_button, { value: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode("样式一")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio_button, { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("样式二")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio_button, { value: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("样式三")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio_button, { value: 3 }, {
                        default: _withCtx(() => [
                          _createTextVNode("样式四")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemKey, null, {
                default: _withCtx(() => [
                  _createTextVNode("店家/品牌介绍")
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemValue, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_flex, {
                    vertical: "",
                    gap: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: _unref(introduction).config.shop_content,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(introduction).config.shop_content) = $event)),
                        placeholder: "填写店家/品牌介绍",
                        "auto-size": { minRows: 2, maxRows: 5 }
                      }, null, 8, ["value"]),
                      _createVNode(_component_a_flex, { gap: "small" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editor).activity?.data.introduction_contents, (c, k) => {
                            return (_openBlock(), _createBlock(_component_a_typography_link, {
                              key: k,
                              onClick: ($event: any) => (_unref(introduction).config.shop_content=c.content)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("示例" + _toDisplayString(k + 1), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128)),
                          _createVNode(_component_a_typography_link, {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(introduction).config.shop_content=''))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("自定义")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemKey, null, {
                default: _withCtx(() => [
                  _createTextVNode("风采展示图片")
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemValue, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(introduction).config.content_images, (i, k) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item",
                        key: i,
                        draggable: "true",
                        onDragstart: ($event: any) => (onDragStart($event,k)),
                        onDragenter: ($event: any) => (onDragEnter($event,k)),
                        onDragend: onDragEnd,
                        onDragover: onDragOver
                      }, [
                        _createVNode(_unref(DragOutlined), { class: "drag" }),
                        _createElementVNode("img", {
                          src: i.includes('dummyimage.com') ? i : i+'-720p',
                          alt: ""
                        }, null, 8, _hoisted_3),
                        _createVNode(_unref(CloseOutlined), {
                          class: "close",
                          onClick: ($event: any) => (_unref(introduction).config.content_images.splice(k,1))
                        }, null, 8, ["onClick"])
                      ], 40, _hoisted_2))
                    }), 128)),
                    (_unref(introduction).config.content_images.length==0)
                      ? (_openBlock(), _createBlock(_component_a_empty, {
                          key: 0,
                          description: "暂无配图"
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_flex, { gap: "small" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_upload, {
                          data: uploadData,
                          accept: ".jpg,.jpeg,.png",
                          "show-upload-list": false,
                          multiple: true,
                          "before-upload": beforeUpload,
                          action: "https://activity-guandb-cn.oss-cn-shanghai.aliyuncs.com",
                          onChange: onUploadChange
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, { type: "primary" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloudUploadOutlined)),
                                _createTextVNode(" 本机上传 ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(WxUploaderButton, {
                          onOnUploadImage: _cache[3] || (_cache[3] = i => _unref(introduction).config.content_images.push(i))
                        }),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (info.pictures.open=true))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CloudOutlined)),
                            _createTextVNode(" 选择配图 ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_a_typography_text, { type: "secondary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("上传活动商品、项目、服务、门店环境图片等")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemKey, null, {
                default: _withCtx(() => [
                  _createTextVNode("活动须知")
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemValue, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_flex, {
                    vertical: "",
                    gap: "middle"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(introduction).config.notice, (v, i) => {
                        return (_openBlock(), _createBlock(_component_a_input, {
                          key: i,
                          value: _unref(introduction).config.notice[i],
                          "onUpdate:value": ($event: any) => ((_unref(introduction).config.notice[i]) = $event),
                          style: {"max-width":"580px"},
                          "allow-clear": "",
                          "show-count": "",
                          maxlength: 60
                        }, {
                          addonAfter: _withCtx(() => [
                            _createVNode(_unref(CloseOutlined), {
                              onClick: ($event: any) => (_unref(introduction).config.notice.splice(i,1))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["value", "onUpdate:value"]))
                      }), 128)),
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(introduction).config.notice.push('')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("添加")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_drawer, {
            open: info.pictures.open,
            "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => ((info.pictures.open) = $event)),
            title: "选择配图",
            placement: "right",
            size: "large"
          }, {
            extra: _withCtx(() => [
              _createVNode(_component_a_flex, { gap: "small" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (info.pictures.open=false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("确定")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(Waterfall), {
                list: _unref(editor).activity!.data.pictures as ViewCard[],
                breakpoints: {1000:{rowPerView:4}},
                lazyload: false
              }, {
                item: _withCtx(({item}) => [
                  _createElementVNode("div", {
                    class: "image-pick-item",
                    onClick: ($event: any) => (onPictureClick(item.url))
                  }, [
                    _createVNode(_unref(LazyImg), {
                      url: item.url,
                      class: "image"
                    }, null, 8, ["url"]),
                    (_unref(introduction).config.content_images.find(i => i == item.url))
                      ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                          key: 0,
                          class: "pick-icon"
                        }))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_4)
                ]),
                _: 1
              }, 8, ["list"])
            ]),
            _: 1
          }, 8, ["open"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})